// App-Version-Accessor (Baustein 6.254). Wird importiert von
// src/lib/appVersion.ts (UI-Footer), api-src/health.ts (/api/health) und
// src/lib/query/client.ts (QUERY_CACHE_VERSION als "v"+APP).
//
// Die Versions-ZAHL steht NICHT mehr hier, sondern in `v6/app-version.json`
// (Single Source of Truth, beim Bump die EINZIGE Datei). Diese Datei liest sie
// zur Build-Zeit aus `process.env.APP_VERSION`, das esbuild (scripts/bundle-
// api.mjs) + Vite (vite.config.ts) aus app-version.json STATISCH ersetzen;
// Fallback "dev" greift in jedem Build-Pfad ohne Injektion (Vitest, roher
// node-Aufruf). Im FE-Bundle ersetzt das Vite-define den Ausdruck statisch —
// KEIN process-Zugriff zur Laufzeit im Browser.
//
// WARUM diese Entkopplung (empirisch verifiziert, beide Fallen gelten):
//   1. Turbo hasht `package.json` ZWINGEND in JEDEN Task-Cache-Key (kein
//      `inputs`-Override) → eine Version dort macht jeden Bump zum Full-Bust.
//   2. `shared/` IST das Workspace-Paket `bergler-shared`; jede Aenderung an
//      einer shared/-Datei fliesst ueber `hashOfInternalDependencies` in den
//      GLOBALEN Turbo-Hash → invalidiert ebenfalls jeden Task. Eine hier
//      hartkodierte Version koennte man NICHT per `inputs` ausschliessen.
// Deshalb lebt die Bump-Zahl in `app-version.json` (Root des `.`-Pakets, nicht
// shared/, nicht package.json). turbo.json listet sie NUR in den Inputs von
// bundle-api + build:fe (die backen die Version ein → bauen beim Bump korrekt
// neu); typecheck/test/contrast-audit/size sehen sie nicht → ihr Cache
// ueberlebt einen reinen Version-Bump. package.json.version ist eingefroren
// ("0.0.0"). Self-Test `version-alignment` prueft Code <-> deployed /api/health.
// 6.217.0 — 6.273-Backstop: Wall-Clock-Budget in recomputeGlobal. Die 6.216.0-
// Per-Pass-Logs zeigten den 14:30-Run: SUCCESS in 16'952 ms, davon projects-Pass
// 12'158 ms (106 Projekte). Der saubere Lauf ist ~17s — die 12:30/13:30-Timeouts
// (504 nach 300s, stuck running) waren INTERMITTIERENDE Contention (viele Crons
// feuern gleichzeitig zu :00/:30 und saettigen den max=1-Pooler), NICHT
// aggregierte Code-Slowness. Damit war die Plan-Chat-Annahme „Budget heilt nicht
// (Lauf inhaerent >300s)" auf falscher Praemisse. Fix (Defense in Depth, analog
// 6.268/6.272): RECOMPUTE_RUN_BUDGET_MS=230_000, am Schleifenkopf jedes Per-
// Entity-Loops (runBudgetedLoop-Helper) + vor den Single-Shot-Passes geprueft;
// bei Ueberschreitung Loop-Stop + Rest deferred, Handler endet SAUBER mit
// lastStatus=success (partial) statt 300s-Kill. budget.{exceeded,deferred} in den
// Cron-Stats. Normalfall (17s) triggert das Budget nie. Per-Pass-Timing bleibt
// als permanente Observability. injizierbares budgetMs+clock fuer Tests. +2 Tests
// (nicht-gerissen / gerissen-nach-2-Projekten-Rest+SingleShots-deferred). KEINE
// Migration. (loadAdminUserIds-Hoist als Effizienz-Folge-Baustein notiert.)
// 6.216.0 — 6.273-Diagnose: 6.215.0 (Projekt-Loop applicable UNION existing) ist
// LIVE, aber notification-rebuild timeoutet WEITER (12:30-Run 504 nach 300s,
// settings haengt auf running). Messung via Mgmt-API: applicable-Projekte=106
// (lead 77 + in_progress 27 + lead_in_contact 2), nicht ~30-50 — die Reduktion
// 273->~150 ist nur 2x, der Projekt-Loop bleibt schwer (jedes recomputeForProject
// = viele serialisierte Queries bei postgres-js max=1). Hypothese „Projekt-Loop
// = DER Bottleneck" war unvollstaendig. Memory workflow_cron_timeout_budget:
// ERST messen. Dieser Cut fuegt NUR Per-Pass-Timing-Logs in recomputeGlobal ein
// (lap(pass,count) loggt ms+sinceStartMs pro Pass, ueberlebt den 300s-Timeout →
// der letzte geloggte Pass zeigt wo der Kill zuschlug). KEINE Logik-Aenderung,
// reine Diagnose. Echter Fix folgt nach Log-Auswertung.
// 6.215.0 — 6.273: Production-Hardening P1. notification-rebuild riss die 300s,
// weil NotificationProjector.recomputeGlobal als EINZIGE der 10 Sources OHNE das
// `applicable UNION existing`-Filter-Pattern lief — der Projekt-Loop iterierte
// pauschal ALLE ~274 Projekte via ProjectRepo.listAll (Befund 2026-06-13: alle
// notification_items aller Source-Types stale seit 06:01, der */30min-Cron hing
// auf running). Fix (Option A, Prinzip-1-konsistent): (1) neue Repo-Methode
// ProjectRepo.listIdsForNotificationRecompute — STATUS-basierter Filter (status
// IN lead/lead_in_contact/in_progress), NICHT updated_at-basiert (die drei
// zeitbasierten Lead-Notifications haengen am created_at; ein 15-Tage-Lead ohne
// updated_at-Change bleibt applicable). Projekt-Loop = applicable UNION existing
// project-source-ids (Cleanup-Pfad Lead->won). 274 → ~30-50. (2) Der owner-
// aggregierte project_calc_data_missing (completed-ohne-Calc) laeuft in einem
// SEPARATEN Owner-Pass (detectProjectsCalcMissing -> distinct Owner UNION
// existing owner_calc_bundle), weil completed-only-Owner aus der applicable-
// Projekt-Menge fallen wuerden. Drift-Schutz: Kopplungs-Kommentar am Repo-Filter
// UND am Projektor. Backstop (Wall-Clock-Budget) bewusst DEFERRED auf Folge-
// Baustein — der Status-Filter haelt die Menge naturgemaess klein (aktive Arbeit
// ist begrenzt), das Budget ist hypothetische Pilot-Skalierung (Prinzip 11).
// Tests: +6 in notification-projector (Throughput-Guard listAll-nicht-aufgerufen,
// applicable-UNION-existing-Dedup, ZEITBASIERT-Guard 15-Tage-Lead->critical,
// existing-Cleanup won->prune, Owner-Calc-Pass completed-only + Cleanup,
// recompute-Set << alle). KEINE Migration.
// 6.214.0 — 6.272: Production-Hardening P1. Cron-300s-Timeouts bei externe-API-
// Crons. Befund 2026-06-13 (Supabase settings cron.*): grok-assign-projectlead
// (xAI, seit 05:30), onedrive-gemeinde-scan (Graph, seit 03:00), onedrive-
// folder-scan (Graph, seit 07:00) hingen auf lastStatus="running" — separate
// Lambda-Invocations mit verschiedenen Startzeiten, jede bei 300s gekillt
// (NICHT Router-Buendelung). Root-Cause: Graph/xAI/bexio-Client hatten KEINEN
// Fetch-Timeout — ein einzelner haengender Call laeuft bis zum 300s-Ceiling.
// Beleg: grok-assign hat bereits Per-Projekt-Timeout (50s) + Init-Timeout (90s),
// hing TROTZDEM — N×50s uebersteigt 300s (per-call begrenzt Einzel-Call, nicht
// Summe). Fix Defense-in-Depth (analog 6.268): (1) Wurzel — generischer
// withFetchTimeout-Wrapper (src/lib/http/fetchWithTimeout.ts, AbortController +
// Promise.race-Hard-Cap) am fetchImpl-Chokepoint aller drei Clients (xAI 60s,
// Graph/bexio 30s); KEIN Einzel-Call reisst mehr das Ceiling, deckt ALLE Crons
// + on-demand-Pfade. (2) Schleifenkopf — Per-Run-Wall-Clock-Budget
// (RUN_BUDGET_MS=230s, injizierbares budgetMs+clock) in runGrokAssignProjectlead
// + runOnedriveGemeindeScan; Rest deferred (oldest-first), stats.budget.
// {exceeded,projectsDeferred}. (3) Stale-Cleanup: 3 haengende running-settings
// einmalig via Supabase-PAT auf error zurueckgesetzt. postgres-js max=1: KEINE
// Parallelisierung. Tests: fetch-with-timeout (7: normal/hang-via-race/Caller-
// abort/Signal-Pass/echte-Fehler-propagiert) + grok-assign + onedrive-gemeinde-
// scan-budget (je 3: nicht-erreicht/reisst-nach-2/budgetMs=0). KEINE Migration.
// 6.209.0 — 6.267: Production-Bug-Fix P0. `grok-insights-refresh-entities`-Cron
// warf seit 6.260 einen echten TypeError ("string argument must be of type
// string … Received an instance of Date") und failte komplett → insights_cache
// nicht refreshed. Root-Cause: InsightsRepo.activeCustomerIds/activeProjectIds
// (6.241) interpolierten ein blankes JS-Date (cutoff) in raw drizzle-`sql`-
// Fragmente; unter prepare:false (Supabase-Pooler) serialisiert postgres-js den
// Bind-Param via b.str()/Buffer.byteLength(date) → Crash <100ms nach Start (vor
// jedem xAI-Call). `gte(col, cutoff)` ist NICHT betroffen (drizzle mapped Date→
// ISO via Column-Typ); nur raw-`sql` ohne Column-Typ. Fix: cutoff.toISOString()
// in allen raw-Fragmenten. Zweite Fundstelle (Sweep, gleicher Footgun):
// InvoiceRepo.aggregateRevenueComparison (/api/finance/revenue-comparison) — 5
// bare Dates gegen invoices.issued_at, ebenfalls auf ISO-String umgestellt.
// Regression-Guard: tests/db-date-param-no-bare-date.test.ts (PgDialect-Param-
// Typ-Check, kein bare Date im Bind-Param-Array). KEINE Migration.
// 6.189.0 — 5.230-os (OS-Teil): BESS-Produkt-Meta-Endpoint als Single Source
// of Truth fuer den Web-Konfigurator. Neuer GET /api/partners/bess-product-meta
// liefert die aktiven Batterie-SKUs (master_products, kind='product' +
// category='battery') mit den technischen display_attributes (sku/voltage/kwh/
// kw/dc/form/cellCount/ukwh/bkg/noOffgrid). EK-Schutz: KEIN ek_chf_pure/
// partner_base_chf/uvp_chf in der Response — das Mapping liegt im Service-Layer
// (MasterCatalogService.listBessProductMeta), der die Preis-Spalten gar nicht
// durchreicht (Defense in Depth). Auth: X-API-Key (PARTNER_API_KEY, gleicher
// Cross-Repo-Mechanismus wie quotes + customer-quote-from-bess; Web-Repo besitzt
// den Key bereits). unauth → 401. Response-Shape { ok, data: { products: [...] }}.
// KEINE Migration (display_attributes existieren seit 0079). Web-Repo-Teil
// (dynamischer Catalog-Load + Generic-Logic + src/lib/bess/products.ts obsolet)
// bleibt offen fuer separate Session. Tests: api-bess-product-meta-endpoint
// (8: Method-Gate/Auth/Shape/EK-Leak/CORS/Service-Throw) + master-catalog-bess-
// meta (4: Mapping/EK-Leak/Coercion/Empty). Endpoint-Dir partners/ (plural) statt
// spec-singular partner/ — Konsistenz mit allen existierenden /api/partners/*.
// 6.188.0 — 5.234-os: Partner-Marge + Kategorien-Visibility pro Partner
// (Daniel-Spec 2026-05-27 + AskUserQuestion-Entscheide). Pricing-Hebel-
// Konsolidierung: per-Partner Bergler-Marge (`partner_profiles.bergler_markup_
// percent`, Migration 0081, Default 15) ERSETZT den globalen 15%-Aufschlag +
// den freien Discount-% (5.133). partner_price = ek_chf_pure × (1 + markup/100);
// Marge 15 == frueherer 0%-Discount (EK × 1.15). UVP bleibt FEST. discount_percent
// bleibt Legacy/Audit-Spalte (Service-Layer ignoriert sie). Backfill markup =
// GREATEST(0, 15 - discount). (a) Migration 0081 (markup numeric(5,2) CHECK 0-50
// + visible_category_slugs text[] NULL). (b) PartnerCatalogService.rebuild liest
// markup statt Discount + filtert master_products strikt nach visible_category_
// slugs (Daniel-Entscheid 2026-05-29: Whitelist gated den GANZEN Catalog, NULL=
// alle, []=nichts; Zubehoer ohne browsbaren product_categories-Slug faellt unter
// gesetzter Whitelist raus). Verifiziert: bess_config-Submit umgeht partner_catalog
// (BESS-Konstanten), strikt-Filtern bricht den Konfigurator NICHT. (c) neuer shared
// Helper category-visibility.ts (categorySlugForMaster via form+dc, isMasterVisible
// ForPartner). (d) Service setMarkupPercent + setVisibleCategorySlugs ersetzen
// setDiscountPercent; approve + rebuildForAllApprovedPartners ziehen markup+slugs.
// (e) Endpoints set-markup + set-categories (admin+superadmin), set-discount
// geloescht. (f) UI: Inline-Discount-Edit raus, PartnerEditModal (Marge-Input +
// Preis-Vorschau + Kategorien-Checkboxen, "Alle"=NULL) hinter Pencil-Button im
// Approval-Tab. (g) EK_TO_RESELLER_MARKUP-Konstante in bessPricing.ts unveraendert
// (Calc-Seeds/master-Rebuild bleiben global). Tests: partner-pricing-policy +
// partner-catalog-rebuild auf Markup migriert, neuer partner-category-visibility
// (strikt-Filter-Coverage), partner-portal-panel Edit-Modal-Tests, approval-service
// setMarkup/setCategories. full suite 6089 passed (1 Baseline-Flake vercel-ignore).
// Migration 0081 wird Plan-Chat-seitig via Mgmt-API appliziert + Catalog-Rebuild
// verifiziert. Web-Repo unveraendert.
// 6.187.0 — 5.238-os: Faellige Rechnungen 1-Klick-Ignorieren statt Dropdown
// (Daniel-Spec 2026-05-28). NotificationDismissBar bekommt einen generischen
// Pfad: ein status-snoozable-Type mit genau EINER snoozeOption rendert einen
// direkten 1-Klick-Button (BellOff-Icon, analog event-Mode) statt des
// DropdownMenu; Klick feuert fireDismiss(snoozeOptions[0]) sofort. typeBehavior
// invoice_overdue snoozeOptions [1,7,30] → [7], damit der 1-Klick-Pfad greift
// (7-Tage-Snooze, status-snoozable — Mahnung kommt wieder bis bezahlt, KEIN
// permanentes Dismiss). Bei >= 2 Optionen bleibt das Dropdown (andere snoozable-
// Types unveraendert). Bundle-Pfad folgt derselben Logik. Daniel-Daily-Driver-
// UX: bei 13+ Mahnungen auf dem Cockpit ist mehr als ein Klick zu viel Reibung.
// Side-Effect: lead_to_contact ([3], bereits single-option) bekommt durch die
// generische Logik ebenfalls den 1-Klick-Button — UX-konsistent. Neuer Test
// notification-dismiss-bar-single-snooze.test.tsx (4 Tests, inkl. multi-option-
// Regression-Guard). full suite 6067 passed (1 Baseline-Flake vercel-ignore).
// 6.186.0 — 5.235-os: Alle 10 ECC-Varianten als editierbare master_products-
// Rows + ECC-Single-Source-Konsolidierung (Daniel-Spec 2026-05-27). Die
// Zwei-Konstanten-Drift (BESS_ECCS 10 Varianten vs RENEPOLY_ECC_CABINET_
// VARIANTS 4 qty-Range-Buckets) ist aufgeloest: RENEPOLY_ECC_CABINET_VARIANTS
// geloescht, BESS_ECCS (shared/bess/ecc.ts) ist die einzige ECC-Preisquelle.
// (a) EccCabinetType-Enum von standalone/ecc2p_3p/ecc4_6p/ecc7_10p auf
// standalone/ecc2..ecc10 erweitert (10 Varianten, kein ecc1; standalone ==
// BESS_ECCS ecc0). (b) Neue Pure-Functions in seeds/bess.ts: eccCabinetDef
// (EK/UVP/Label aus BESS_ECCS), eccVariantToBessEccKey, ECC_CABINET_VARIANTS
// (drift-frei aus dem zod-Enum). selectEccCabinetVariantByBessQty mappt qty
// jetzt exakt (1→standalone, 2..10→ecc2..ecc10, >10→ecc10) statt Range-
// Bucketing. (c) masterCatalog.buildMasterCatalogFromBessSeed erzeugt 10
// ECC-Rows (ECC_standalone + ECC_ecc2..ECC_ecc10, kind=ems, category=
// ecc_cabinet) statt 4 Buckets; alte Bucket-SKUs verschwinden beim Rebuild.
// Gesamt-Catalog jetzt 65 Rows (war 59). (d) offerPdf isEccCabinetVariant
// drift-frei gegen das zod-Enum. (e) BessConfiguratorModal ECC_OPTIONS 10
// Varianten. (f) bess-product-descriptions: 10 ECC-Beschreibungen (Helper
// eccCombinerDescription pro Cabinet-Anzahl). Pricing-Fix: OS-CalcEditor +
// Web-Konfigurator rechnen ECC-Preise jetzt identisch (z.B. qty=6 → 14'647
// statt fruheres Bucket-12'965); standalone minimal 3'600→3'587 (Kruecken-
// Preis, akzeptiert). Cross-Repo-Verifikation: derive.ts (BESS_*-SKUs)
// unveraendert — Submit re-derived via BESS_ECCS, kein partner_catalog-
// Lookup fuer ECC, kein Web-Code-Change. Tests: bess-seed-ecc-variants +
// master-catalog-build + calc-bess-shared-pricing + bess-seed-5-117 +
// seed-bess-calc-v5-11 + bess-product-descriptions auf Single-Source
// migriert; neuer ecc-catalog-10-variants.test.ts.
// 6.185.0 — 5.229-os: Partner-Portal Full-Product-Edit + Soft-Delete
// (Daniel-Spec 2026-05-27 nach 5.228-Smoke "super"). Sandros Self-Service
// pro Produkt: Pencil-Button oeffnet ProductEditModal mit ALLEN Feldern
// (name/description/kind/category/ek/uvp/active/displayAttributes), Trash-
// Button oeffnet Soft-Delete-Confirm (active=false, reversibel), Header
// hat „+ Neues Produkt"-Button DISABLED mit Tooltip „Verfuegbar ab 5.230
// (Catalog-Migration)". (a) Migration 0079: master_products.display_
// attributes erweitert um voltage/cellCount/ukwh/bkg/noOffgrid (Vorbau
// fuer 5.230); Backfill der 10 BAT_*-SKUs aus shared/bess/products.ts +
// BESS_PRODUCT_CELL_COUNT; idempotent via jsonb-||-Merge. (b) Service:
// MasterCatalogAdminService.updateFullProduct({sku, patch, actorUserId})
// validiert kind/ek/uvp/name, recomputed partner_base + uvp wenn ek im
// Patch (UVP-Patch wird in dem Fall IGNORIERT — Honest-Pushback), triggert
// synchronen Rebuild fuer alle approved Partner bei partner-visible Field
// (ek/name/description/category/kind/uvp/active/displayAttributes). Audit
// master_product_full_updated + partner_catalog_rebuilt_all. Soft-Delete-
// Methode softDeleteProduct setzt active=false + Audit + Rebuild (Catalog
// blendet SKU aus). (c) Zwei neue Endpoints unter /api/system/ (master-
// product-update + master-product-soft-delete), admin+superadmin guarded,
// vercel.json maxDuration:60. (d) UI: ProductEditModal mit shadcn-Dialog,
// strukturierter BESS-Spec-Form fuer BAT_*-SKUs (voltage-Select + cellCount/
// ukwh/bkg/noOffgrid-Inputs), generischer JSON-Editor fuer Nicht-BAT-SKUs,
// Diff-basierter Patch-Builder (nur geaenderte Felder), Drift-Hint bei
// display_attributes-Edits. ConfirmEditDialog zeigt Preis-Vorschau alt vs
// neu. (e) MasterProductRow erweitert: 3 Action-Buttons (Inline-EK-Edit
// bleibt als 1-Klick-Pfad, Pencil oeffnet Modal, Trash oeffnet Soft-
// Delete-Confirm); inaktive Rows mit Inaktiv-Badge + opacity-60. (f) Hook
// usePartnerPortalConfig erweitert: useUpdateMasterProductFull +
// useSoftDeleteMasterProduct (TanStack-Mutations, Cache-Invalidation).
// (g) masterCatalog.ts: buildMasterCatalogFromBessSeed ergaenzt BAT_*-
// displayAttributes um voltage/cellCount/ukwh/bkg/noOffgrid, damit ein
// Rebuild die neuen Felder nicht wieder wegrasiert. (h) Audit-Types um
// master_product_full_updated + master_product_soft_deleted erweitert.
// Tests: +12 Service-Tests (Recompute-Pfade, statischer UVP, EK-dominiert-
// UVP-Honest-Pushback, displayAttributes-Edit, Reaktivierung, alle
// Validation-Errors, Soft-Delete + NotFound) in partner-portal-product-
// edit.test.ts; +6 UI-Tests in partner-portal-ek-prices-panel-actions.
// test.tsx (Add-Button-Tooltip-Trigger, Inline-EK-Regression-Guard, Pencil
// oeffnet Modal mit BESS-Spec-Form, Trash oeffnet Confirm-Dialog,
// Inaktiv-Badge, Soft-Delete-Mutation-Trigger). Bestehende Test-Mocks in
// partner-portal-panel.test.tsx + partner-portal-panel-tabs.test.tsx um
// die zwei neuen Hooks erweitert. typecheck clean, full suite 6052 passed
// (+18 vs 6034 Baseline, 1 Baseline-Flake vercel-ignore unveraendert),
// build:api 149 Files. Memory project_partner_portal_shop.md Lesson 15-
// prelude: Cross-Repo-Catalog-Architektur ist Sandros Self-Service-Endgame;
// Phasierung (OS-only Vorbau + Cross-Repo-Migration getrennt) klammert
// Drift-Risiken. Add-Flow bleibt geblockt bis 5.230. UI-Drift-Hint im
// Edit-Modal macht display_attributes-Drift bis 5.230 transparent.
// 6.184.0 — 5.228-os: PartnerPortalPanel Drei-Hauptmenue-Architektur nach
// Daniel-Entscheid 2026-05-27 („preise, kategorien und approval als
// haupmenues"). Tab-Bar reduziert von 7 flachen Tabs (5.223) auf 3 Top-
// Level-Hauptmenue-Tabs `Preise | Kategorien | Approval`. Approval-Section
// rendert die 5 Status-Filter (Wartend/Freigegeben/Abgelehnt/Suspendiert/
// Alle) als Sub-Tabs intern (Default Wartend = Sandros Daily-Driver bei
// 5-10 Resellern). Preise rendert PartnerPortalEkPricesPanel inkl.
// PriceFormulaHint (EK x 1.15 x 1.20-Erklaerung); Kategorien rendert
// PartnerPortalCategoriesPanel. URL-Routing `?tab=preise|kategorien|
// approval&status=...`. Backward-Compat-Aliase im resolveTabs-Resolver:
// `?tab=ek-preise → preise` (5.223-Bookmark-Compat); `?tab=wartend|
// freigegeben|abgelehnt|suspendiert|alle → approval&status=...`
// (5.132/5.220-Notification-Click-Target-Compat). Default-Landing ohne
// `?tab`: `approval+wartend`. App.tsx /system/config/partner-portal-
// Redirect target von `?tab=ek-preise` auf `?tab=preise`. Tests komplett
// auf 5.228-Design: partner-portal-panel-tabs.test.tsx (25 Tests — 3
// Main-Tabs + 5 Sub-Status + Default-Landing + 6 Backward-Compat-Aliase),
// partner-portal-panel.test.tsx Tab-Layout-Block angepasst (3 Main +
// 5 Sub-Sichtbarkeit). usePartnerPortalConfig-Mock zu panel.test.tsx
// hinzugefuegt (Preise-Section rendert EK-Panel mit useQuery).
// Verifikation: typecheck clean, partner-portal-Tests gruen (alle
// vorigen 5.139/5.223-Tests passen sich an), full suite 6034 passed
// (1 Baseline-Flake vercel-ignore unveraendert). Memory Lesson 14
// dokumentiert: bei Portal-Pages mit gemischten Aufgaben-Bereichen ist
// 3-Hauptmenue-Architektur UX-konsistent mit Sandros Mental-Model;
// 7 flache Tabs zwingen User zur Re-Klassifikation.
// 6.183.0 — 5.227-os: Crash-Root-Cause-Fix (Connection-Leak in /api/system/
// partner-portal-config). Plan-Chat-Diagnose 2026-05-27 via pg_stat_activity
// in Production zeigte: Query "SELECT sku, display_attributes FROM
// master_products WHERE active=$1" bleibt im `wait_event=ClientRead` haengen.
// Manueller DB-Test der Query: 600ms clean. Bei jedem Page-Refresh leakt
// eine weitere Connection; postgres-js Pool max=1 erschoepft nach 1. Leak,
// alle nachfolgenden Requests timeouten in 300s-Vercel-Timeout. Root-Cause:
// `Promise.all([listCategories, listAll])` im Endpoint queue 2 Sub-Queries
// (effektiv 3 mit der inneren productCategories+masterProducts in
// listCategories) gegen den max=1-Pool. Wenn einer der Result-Streams haengt
// (ClientRead bei Fluid-Compute-Race), blockiert er alle Geschwister.
// Memory `workflow_postgres_pool_max_1.md` warnt seit 5.49 davor — der
// Endpoint hatte das Anti-Pattern uebersehen. Fixes: (1) handleGet
// sequenziell `await ...listCategories(); await ...listAll();` statt
// Promise.all. (2) postgres-Client bekommt `connect_timeout: 10` +
// `connection: { statement_timeout: 20_000 }` als Defense-in-Depth fuer
// ALLE Endpoints. (3) vercel.json `api/system/partner-portal-config.js`
// `maxDuration: 30` — Hard-Cap statt Default-300s, sodass ein hung Lambda
// nicht 5 Minuten Pool-Slots haelt. Tests: full suite 6017 passed (1
// Baseline-Flake `vercel-ignore` unveraendert), 67 partner-portal-Tests
// gruen. typecheck clean, build:api 147 Files unter 6.183.0. 5.226-Hook-
// Timeout aus PartnerPortalPanel-Hook bleibt als Observability-Layer.
// 6.182.0 — 5.226-os: 5.225-Revert + Defensive Hook-Timeout. Daniel-Smoke
// 2026-05-27 nach 5.225-Deploy zeigte: (a) Sheet trennt das Portal in
// zwei mentale Bildschirme statt zu vereinen (5.223-Erfolg rueckgaengig);
// (b) Skeleton-Hang im EK-Panel ist NICHT durch das Refactor verschwunden
// — er war NIE durch UI-Layout verursacht. Code-Review hatte den echten
// Hook-Bug verfehlt. Revert: PartnerPortalPanel.tsx + PartnerPortalPage.tsx
// zurueck auf 5.223-State (7-Tab-Layout, kein Sheet, kein Header-Button).
// Echter Root-Cause des Skeleton-Hangs ist mit den verfuegbaren Tools
// nicht remote reproduzierbar (Auth-Token fuer Sandros Session noetig);
// Production-Endpoint-Curl ohne Auth antwortet sauber 401 in <1s, kein
// Cold-Start-Fail. Daher Observability statt Spekulation: apiGet bekommt
// optionalen `signal: AbortSignal` Parameter; `usePartnerPortalConfig`
// nutzt AbortController + 20s-Timeout. Bei Hang wirft der Hook explizit
// `Timeout (20s) — ... Browser-DevTools-Network-Tab pruefen` statt
// indefinit isLoading=true zu bleiben. Sandro/Daniel sieht dann beim
// naechsten Auftreten eine ErrorBox mit klarem Hinweis. Tests unveraendert
// auf 5.223-State zurueck (8 + 18 + 4 = 30 passed). +1 apiGet-Signature-
// Erweiterung (rueckwaertskompatibel: `options` ist default-{}). Memory
// Lesson 13 muss korrigiert werden (Sheet-Pushback war Fehlentscheid).
// 6.181.0 — 5.225-os: PartnerPortalPanel UI-Hierarchie-Fix. 5.223 hatte
// EK-Preise + Kategorien als erste Top-Level-Tabs vor Wartend gesetzt,
// das war falsche Hierarchie: Sandros Daily-Driver bei 5-10 Resellern
// ist Status-Pflege (90% der Zeit), EK-Editing max 2-4×/Jahr bei
// FX-Schwankungen. Tab-Bar zurueck auf 5 Status-Tabs (Wartend/Frei-
// gegeben/Abgelehnt/Suspendiert/Alle); Master-Catalog (EK + Kategorien)
// wandert hinter einen Settings-Button im PageHeader, der ein rechtes
// Sheet oeffnet mit zwei internen Sub-Tabs „EK-Preise" + „Kategorien".
// Sheet via existing shadcn-Sheet (Radix-Dialog, desktop-correct) statt
// Vaul-Drawer (mobile-only-optimiert) — Honest-Pushback gegen ROADMAP-
// Spec, kein neuer Dep noetig. URL-Backward-Compat: `?tab=ek-preise`
// + `?tab=kategorien` oeffnen Sheet mit dem Sub-Tab; Sheet-Close setzt
// `?tab=wartend`. Header-Button data-testid `partner-portal-master-
// catalog-button`, Sheet data-testid `partner-portal-master-catalog-
// sheet`, Sub-Tabs `partner-portal-master-sub-tab-{ek-preise,kategorien}`.
// PartnerPortalPage.tsx: PageHeader.actions={<PartnerPortalMasterCatalog
// Button />}. Crash-Diagnose (Skeleton-Hang aus 5.223-Smoke) ergab
// keinen Hook-Bug (usePartnerPortalConfig fires unconditional on mount,
// kein enabled-Gate, kein staleTime:Infinity, Persist-Cache busted via
// QUERY_CACHE_VERSION); most-likely Cause war Sandros gecachter
// pre-5.220-JS-Bundle. Refactor macht Symptom strukturell irrelevant:
// EK-Preise ist nicht mehr im Default-Landing-Path, sondern explizit
// hinter Button-Click → kein First-Impression-Hang moeglich.
// Tests: partner-portal-panel-tabs.test.tsx neu auf 5.225-Design
// (5 Status-Tabs only, Header-Button rendert, ?tab=ek-preise → Sheet
// offen, beide Sub-Tabs sichtbar, Loading + Error im Sheet). partner-
// portal-panel.test.tsx: „alle sieben" → „alle fuenf". +12 + 18 Tests
// gruen, volle Suite 6020 passed (zwei Baseline-Flakes: vercel-ignore
// + portal-orders-Timeout unter Parallel-Load, passt in Isolation).
// 6.180.0 — 5.224-os: BESS-Catalog Voltage-Badge + Trafo „Preis auf
// Anfrage" (Cross-Repo mit Web Session A). Neue BessVoltage-Property in
// shared/bess/products.ts (400V Cabinets+AC, 690V ES3344, dc DC-Container).
// shared/bess/derive.ts: Trafo-Logik refactored — voltage="dc"|"690V"
// produziert priceOnRequest:true-Line mit totalEk:0 (statt hardcoded
// TRS-5000 RP_TRAFO_EK=330'237), voltage="400V" produziert KEINE Trafo-
// Line. partnerQuoteIntake: BessFlatCartItem.unitPriceChf akzeptiert null
// + priceOnRequest-Flag, derivedLinesToFlatCartItems supportet priceOnRequest,
// normalizeBessEndCustomerOverrides skipped Floor-Check fuer priceOnRequest-
// SKUs, buildRecomputeFromDerived reicht Flag in OfferPdfItem durch.
// customerQuoteFromBessService analog: recomputeBessEndCustomer +
// recomputeBessCartEndCustomer skipped priceOnRequest in End-Customer-
// Total + setzen OfferPdfItem.priceOnRequest. PDF-Render: neuer
// PRICE_ON_REQUEST_LABEL in shared.ts; formatChfOrHidden dominiert
// priceOnRequest ueber hide; bessOfferHtml + chargingListHtml reichen
// it.priceOnRequest durch. +35 Tests (voltage-Mapping 11, derive 7,
// flat-cart 4, normalize 3 in partner-quote-intake-trafo-on-request;
// formatChfOrHidden 4, html-templates 3, recompute 3 in customer-quote-
// pdf-trafo-on-request). Pricing-Impact: DC-Container-Totals sinken um
// 330'237 CHF (sachlich richtig, war nie pro Container passend).
// 6.179.0 — 5.223-os: Partner-Portal-UI-Konsolidierung. EK-Preise +
// Kategorien sind jetzt Nav-Tabs auf /partner-portal (Top-Nav „Verwaltung")
// statt versteckt unter /system/config/partner-portal. Sandros mentales
// Modell: alles Partner-bezogene auf einer Page. Tab-Reihenfolge: EK-Preise
// | Kategorien | Wartend | Freigegeben | Abgelehnt | Suspendiert | Alle.
// PartnerPortalConfigPanel.tsx refactored zu zwei Top-Level-Panels
// (PartnerPortalEkPricesPanel + PartnerPortalCategoriesPanel), beide ueber
// usePartnerPortalConfig (TanStack-Cache shared). SystemShell-Sub-Tab
// „Partner-Portal" entfernt; /system/config/partner-portal jetzt
// Navigate-Redirect auf /partner-portal?tab=ek-preise (ausserhalb
// RequireSuperadmin, damit admin Sandro auch redirected wird). +12 Tests
// (8 Master-Tabs + 4 Redirect-Guards).
// 6.178.0 — 5.222-os: Auth-Config-Drift-Detection-Self-Test. Expected-Snapshot
// in shared/auth/expectedAuthConfig.ts (rate_limit_email_sent: 30 et al.),
// authConfigDrift-Service fetcht via Supabase-Mgmt-API + diff'd, neuer
// Self-Test `auth-config-drift` in der Registry (+ Cockpit-Card „Extern"),
// neuer Notification-Type `auth_config_drift_detected` (admin/superadmin,
// status-snoozable) inkl. Row + Badge. Defense gegen Pilot-User-blockierende
// Stale-Auth-Settings (5.140-Spaetfolge in liesan-Account). +15 Tests.
// 6.177.0 — 5.220-os: OS-Admin Partner-Portal-Config (/system/config/
// partner-portal). Neue Tabelle product_categories (Migration 0078) mit
// 6 Slugs (3 BESS-aktiv, 3 Vorbau-inaktiv: charging/pv/wp). Zwei neue
// Admin-Services (ProductCategoryAdminService + MasterCatalogAdminService)
// in partnerPortalConfig.ts; rebuildForAllApprovedPartners() triggert
// synchron bei EK-Update. Drei neue Endpoints unter /api/system/
// (partner-portal-config GET / product-category-toggle POST /
// master-product-update-ek POST). Neuer Config-Sub-Tab + Panel mit
// Kategorie-Toggles + EK-Editor inkl. Confirm-Dialog. +7 Service-Tests.
// 6.176.0 — 5.218-os: Margin-Formel-Sync zu Web-Repo-5.214 (P0-Bugfix
// fuer 422 ENDCUSTOMER_MISMATCH bei Default-20%-Marge). Neue Konstante
// DEFAULT_END_CUSTOMER_MARGIN_PCT=20 + Helper endCustomerFactorFromMarginPct
// in shared/bess/constants.ts; alle 4 Default-Endkunden-Pfade in
// customerQuoteFromBessService + customerQuotePdf nutzen jetzt
// partner / (1 - 20/100) statt partner × 1.20. RS=1.2 BLEIBT fuer
// Catalog-productUvp. +9 Anti-Drift-Tests in bess-end-customer-margin.test.ts.
// 6.175.0 — 5.212-os: Multi-Line-Cart-Support — bessCartSchema (lines[]) +
// submitBessCart-Pfad in partnerQuoteIntake + customerQuoteFromBess mit
// pre-built Multi-Section-DTO, nested endCustomerOverrides per lineId.
// Single-Line `bess_config` bleibt Backward-Compat.
// 6.174.0 — 5.211-os: customerQuoteFromBessCustomerSchema lockern (displayName
// optional, lastName neu, refine name-OR-firma, CUSTOMER_NAME_REQUIRED → 422),
// buildOfferPdfCustomer mit firstName+lastName-Fallback.
// 6.190.0 — 5.239-os: Bergler-Marge Cap 35% + Default 18% (Daniel-Spec
// 2026-05-30 nach Sandro-UVP-Verstaendnis-Frage). Sandro hatte den Edge-Case
// entdeckt: bei Marge 50% (alter DB-Cap) lag der Partner-Preis UEBER dem UVP
// (EK × 1.20), der Partner verlor beim Verkauf. Daniel-Entscheid: (i) CHECK auf
// 0..35 (bei 35% behaelt der Partner ~2% Restmarge), (ii) Default 15 -> 18
// (Bergler/Partner ungefaehr halb-halb). Code-Side nachgezogen zur schon via
// Plan-Chat-Mgmt-API live applizierten Migration 0082 + Backfill + Catalog-
// Rebuild: (a) Migration-File 0082 (idempotent: SET DEFAULT 18.00, CHECK 0..35
// statt 0..50, Backfill 15.00 -> 18.00). (b) shared/partners/pricing-policy.ts:
// PARTNER_MARKUP_PERCENT_MAX 50 -> 35, _DEFAULT 15 -> 18 (Single Source, alle
// Endpoints/Services/UI lesen daraus). (c) partnerApproval.setMarkupPercent +
// partnerCatalog.rebuild Error-Messages + `?? 15`-Fallbacks auf die Konstanten
// migriert. (d) Drizzle-Schema partner_profiles.berglerMarkupPercent .default
// "15" -> "18". (e) UI PartnerEditModal: Label/Range aus Konstanten (max 35),
// neuer "Empfohlen 18% (Standard)"-Hint. set-markup-Endpoint zod .max(35)
// automatisch via Konstante. Tests: partner-pricing-policy (Range 0..35 +
// Default 18 + 50/36 reject), partner-approval-service (36 + altes 50 reject +
// 35 akzeptiert), partner-portal-panel (max=35-Attr + Hint + 40/75 disabled),
// partner-catalog-rebuild (35%-Cap-Boundary), neuer migration-0082-markup-cap
// (CHECK 0..35 + DEFAULT 18 + Backfill-Anker). Memory project_partner_portal_
// shop.md schon Plan-Chat-seitig aktualisiert. Web unberuehrt.
// 6.192.0 — 6.240 (Phase 6 Wave 1 A): xAI-Usage-Logging. Sitzt auf 6.241
// (Stale-TTL, 6.191.0) + 6.248 (CI) der parallelen Wave 1; 6.191.0 war von
// 6.241 vergeben → dieser Cut ist 6.192.0. Neue Tabelle
// `xai_usage_log` (Migration 0083, service-only RLS, Index (job, called_at))
// macht den xAI-Token-Bleed messbar (Codex-Befund: ~1'920 idle chat-calls/Tag,
// kein Per-Job-Drilldown). XaiClient.chat() nimmt optionalen `job`-Context
// ({job, entityKind?, entityId?}) und persistiert die Token-Counts aus
// `usage.{prompt,completion,total}_tokens` jeder Response (Default-Sink lazy
// nachgeladen, Typ-only-Import haelt den Lib-Bundle DB-frei). Neuer Service
// `xaiUsage.ts`: logXaiCall() (DB-Fehler verschluckt — Telemetrie bricht den
// Job nie), aggregateForJob(job, fromDate) → {calls, totalTokens, estCostUsd},
// Konstante XAI_COST_PER_1K_TOKENS=0.0015 (blended $1.25/$2.50-1M-Pricing).
// XaiUsageRepo (insert + aggregateForJob mit COALESCE-SUM). Tests:
// xai-usage-log (12: Insert-Mapping, null-Mapping, Fehler-Verschlucken,
// Cost-Math, Aggregat, Client→Sink-Mapping). Backward-Compat: ohne job-Context
// loggt nichts, bestehende Call-Sites unangetastet.
// 6.191.0 — 6.241 (Phase 6a, Wave 1 B): Stale-Age-TTL fuer Entity-Insights.
// Stoppt die ~1'920 idle xAI-chat-calls/Tag (Codex-Befund). Der Cron
// `grok-insights-refresh-entities` rotierte alle 15min durch die N aeltesten
// Cache-Rows, EGAL wie frisch — `listStaleScopes` hatte keine minimum-stale-
// age. Fix: (a) InsightsRepo.listStaleCustomerScopes/listStaleProjectScopes
// bekommen einen `ttlMs`-Parameter → WHERE `refreshed_at IS NULL OR
// refreshed_at < now() - make_interval(secs => ttl)`. (b) Neue Bulk-Lookups
// activeCustomerIds/activeProjectIds (EIN SELECT pro Scope ueber die ≤10
// Kandidaten-IDs, kein Per-Entity-Roundtrip) entscheiden die TTL-Heuristik:
// Aktivitaet in 30d (interactions/invoices/projects.updated_at) → 24h-TTL,
// sonst 7d. (c) grokInsightsRefreshEntities ruft die Repo-Liste mit der
// KUERZEREN TTL (24h) als Floor und verfeinert ruhende Kandidaten danach auf
// 7d (isEntityDue). DoD: Idle-Lauf → 0 Refresh-Calls; genau 1 stale → genau
// 1 Refresh. Tests: insights-repo-ttl (TTL-SQL + Aktivitaets-Signale),
// grok-insights-refresh-entities-ttl (0-Calls-idle, 1-stale-1-call, 24h-vs-7d-
// Heuristik). 6.242 (Cron-Cadence + Snapshot-Hash) baut darauf auf.
// 6.193.0 — 6.246 (Phase 6b, Wave 1 C): E2E-Real-Backend-Modus als Opt-in.
// (6.191.0/6.192.0 gingen parallel an Session B/A; daher 6.193.0.)
// (Daniel-Smoke-Pfad, Vorbereitung fuer den dev:api-Server aus 6.244). (a)
// mockApi.ts bekommt das Flag E2E_REAL_BACKEND — installApiMocks + setupE2EPage
// sind dann No-Ops, /api/*-Requests laufen direkt ans echte Backend. Default
// bleibt Mock (Flag ungesetzt), bestehende Suite unberuehrt. (b) Neue Suite
// tests/e2e/smoke-real-backend.spec.ts (8 Cases): unauth /api/health +
// /api/status + Login-Render + Auth-Gate-Redirect laufen immer; auth-gated
// Project-List + Notification-Center + Self-Test + Partner-Approval skippen
// ohne echten storageState (E2E_REAL_BACKEND_STORAGE). (c) playwright.config.ts:
// neues Project `real-backend` (baseURL = E2E_REAL_BACKEND_URL ?? Production,
// kein lokaler Vite-Server) + Auto-Flag via argv-Detection. (d) package.json:
// Script test:e2e:real = `playwright test --project=real-backend` (cross-
// platform statt POSIX-`VAR=1`-Prefix, der auf Windows bricht). Keine
// Produktiv-Code-Aenderung, nur Test-Infra.
// 6.194.0 — 6.244 (Phase 6b, Wave 2 G): Lokaler Backend-Server `pnpm dev:api`.
// Mini-HTTP-Server (scripts/dev-api.ts, tsx-only Dev-Tooling) bedient die
// api-src/-Endpoints lokal auf Port 3001 mit identischem Verhalten zu den
// Vercel-Functions — Daniel/Sandro testen Backend-Aenderungen ohne Deploy.
// Routing 1:1 zu bundle-api.mjs (api-src/<path>.ts → /api/<path>). Die
// Middleware-Pipe wird NICHT dupliziert: jeder Endpoint exportiert seinen
// default bereits als pipe(withLogger, withAuth, ...)(handler); der Server
// ruft exakt diesen Default-Export — wie Vercel zur Runtime (Prinzip 1).
// Handler werden lazy beim ersten Treffer importiert → Boot in ~100ms (DoD
// <5s) und kein Haengenbleiben am db/client-Boot-Check, solange man env-freie
// Endpoints wie /api/health trifft. tsx-watch startet bei jeder api-src-
// Aenderung neu → naechster Request importiert frisch (DoD Reload <2s). .env.local
// wird dependency-frei geladen (nur fehlende Keys). package.json minimal: nur
// Script `dev:api` + tsx-devDep (6.247-Turbo fasst package.json erneut an).
// eslint ignoriert scripts/**/*.ts (tsx-only, in keinem tsconfig-Project).
// Smoke tests/smoke/dev-api-boot.test.ts: spawnt den Server via `node --import
// tsx` als Child-Prozess, pollt /api/health → 200 + Version-Payload, plus
// 404-JSON auf unbekannte Route. Manueller 5-Endpoint-Smoke (health 200,
// projects/system/partners/finance 401 AUTH_MISSING via echte Pipe) gruen.
// 6.193.0 ging an Session C (6.246); 6.192.0/6.191.0 an Wave 1 → dieser Cut 6.194.0.
// 6.195.0 — 6.243 (Phase 6a, Wave 2 F): Daily-Budget-Guard pro xAI-Job.
// (6.194.0 ging parallel an Session G/6.244 → dieser Cut ist 6.195.0.)
// Defense-in-Depth ueber dem 6.240-Usage-Log + der 6.241-Stale-TTL. Neuer
// Service `xaiBudget.ts`: checkBudget(job, dailyCap) liest die heute (seit
// UTC-Mitternacht) geloggten Calls aus `xai_usage_log` und wirft
// XaiBudgetExhaustedError, sobald count >= cap. runWithXaiBudget() ist der
// Cron-Handler-Einstieg: pre-flight Gate + Job-Context-Injektion via
// withJobContext-Wrapper (schiebt jedem chat()-Call `job` unter → 6.240-Logging
// greift, OHNE die Services anzufassen — sie nehmen den Client via options.xai).
// Caps: entity-insights 50, home-insights 5, match-invoice 100, match-bill 100,
// assign-projectlead 20 (XAI_JOB_DAILY_CAPS, Single Source of Truth). Bei
// erreichtem Cap: warn `budget_exhausted` + Audit-Action `xai_budget_exhausted`
// (entity=system, entityId=job, after={job,dailyCap,count}) + Skip (xAI-Lauf
// entfaellt, Handler antwortet {ok, skipped:"budget_exhausted"}). Audit-Write-
// Fehler werden verschluckt (Skip darf nie crashen). Verdrahtung NUR in den 5
// Cron-Handlern (api-src/cron/grok-*.ts) — disjunkt von 6.242 (Services).
// Optionaler Endpoint GET /api/system/xai-budget (superadmin) zeigt pro Job
// calls+total_tokens+estCostUsd heute gegen den Cap (sequenziell, postgres
// max=1). Tests: xai-budget-service (10: Threshold-Pfade, UTC-Fenster, Skip-
// Verhalten, Audit-Fehler-Verschlucken, withJobContext-Injektion, Cap-Tabelle)
// + Skip-Pfad-Coverage in den 5 Cron-Handler-Tests.
// Der Self-Test `version-alignment` bewacht die Konsistenz beider Seiten.
// 6.196.0 — 6.242 (Phase 6a, Wave 2 E): Cron-Cadence + Snapshot-Hash-Skip +
// (6.194.0/6.195.0 gingen parallel an 6.244 dev:api + 6.243 Budget-Guard;
//  daher 6.196.0.)
// grok-model-alive-24h-Cache. (a) vercel.json: grok-insights-refresh-entities
// */15 → 0 */2 (alle 2h), grok-insights-refresh (home) */30 → 0 6 (daily 06:00).
// (b) Snapshot-Hash (snapshotHash.ts): vor jedem xAI-Call SHA256 des stabilen,
// volatile-bereinigten (generatedAt/daysSinceLastUpdate raus) Snapshots vs.
// content.snapshotMeta.snapshotHash — unveraendert → kein Call, nur
// refreshedAt-Bump via InsightsRepo.touch. In home + customer + project
// verdrahtet. (c) system_cache-Tabelle (Migration 0084) + SystemCacheRepo;
// grokModelAlive-Service cached die /v1/models-Probe 24h, Self-Test
// grok-model-alive liest nur noch {ok, lastCheckAge, lastCheckResult} (<50ms
// statt 2-5s) + lazy-Refresh bei Ablauf; neuer Superadmin-Endpoint
// POST /api/system/grok-model-alive-refresh erzwingt sofortige Probe.
// Tests: snapshot-hash-skip, grok-model-alive-cache, cron-cadence-audit.
// 6.245 (Phase 6b, Wave 3): Vite-Dev-Proxy server.proxy['/api'] →
// http://localhost:${DEV_API_PORT ?? 3001} (changeOrigin, secure:false), damit
// `pnpm dev` gegen den lokalen dev:api-Server (6.244) laeuft statt Mocks —
// Backend-Change → Browser-Reload < 30s ohne Vercel-Deploy. README-Section
// "Lokale Entwicklung mit Backend" (2-Terminal-Workflow, Ports, Troubleshooting).
// E2E-Mock-Pfad (Playwright route-Interception) unangetastet.
// 6.198.0 — 6.247 (Phase 6c, Wave 3 I): Turborepo-Build-Caching ueber alle
// Tasks. Neues v6/turbo.json (Tasks bundle-api, build:fe [deps bundle-api],
// typecheck [deps ^typecheck], test, contrast-audit, size [deps build:fe])
// mit praezisen inputs/outputs pro Task — Docs-only-Commit → FULL-TURBO-
// Cache-Hit (<1s gegen ~34s cold), FE-only-Commit → bundle-api Cache-Hit +
// nur build:fe rebuild. Architektur-Entscheid (App liegt im Workspace-Root,
// nicht in einem Sub-Package → Task-Name == npm-Script-Name wuerde Turbo in
// Endlosrekursion schicken): die echten Commands behalten ihre Script-Namen
// (Turbo cached sie via `turbo run X`), nur `build`/`build:api` werden
// rekursionssichere Wrapper mit abweichendem Namen (`turbo run bundle-api
// build:fe` / `turbo run bundle-api`). `build:api` ist identisch zu
// `bundle-api`, daher Wrapper statt Doppel-Task (Prinzip 1). Cache-Stabilitaet:
// das generierte `shared/migrations-manifest.ts` ist Output, aber via
// `!`-Negation aus den Inputs von bundle-api + build:fe ausgeschlossen (sonst
// Self-Invalidation durch LF/CRLF-Drift auf Windows; Wahrheitsquelle bleibt
// drizzle/migrations/**). env-Hash nur auf build:fe (Sentry/NODE_ENV), nicht
// auf Tasks die keine env brauchen. vercel.json buildCommand → turbo,
// .turbo gitignored. Test tests/turbo-config.test.ts (12 Schema-Checks).
// Remote-Cache (TURBO_TOKEN als Vercel-Env) bleibt Plan-Chat-Folgeschritt.
// 6.199.0 — 6.249 (Phase 6d, Wave 4 J): API-Bundle-Grouping-Spike + Gate-
// Entscheid. Forschungs-Baustein, KEINE Production-Aenderung. Misst, ob das
// Zusammenfassen einer Domain (system/, 26 Endpoints) hinter EINEM Hono-Router
// kleinere Bundles bringt. (a) tools/measure-bundle.mjs: Build-Walltime (1 cold
// + 3 warm, ruft scripts/bundle-api.mjs direkt → isoliert Bundling von
// Turbo-Cache), Gesamt-Output-Size (in-process du-Aequivalent), Per-Function-
// Histogramm, Function-Count, system-Domain-Subtotals → JSON. (b) api-src/
// system/_all.ts: Hono-Router, der alle 26 system/*-Handler ueber einen
// adapt()-Shim (Hono-Context ↔ Vercel-Request/Response) subroute't. (c)
// bundle-api.mjs: GROUPED-Schalter — Default ueberspringt _all.ts (Production
// 1:1 unveraendert, Null-Risiko), BUNDLE_GROUPED=1 ersetzt in Router-Dirs die
// Single-Files durch den Router (reales "26 → 1"). (d) Messung: baseline-bundle
// .json + grouped-bundle.json. (e) docs/bundle-grouping-spike.md. ERGEBNIS:
// system-Domain 6.05 MB (26 Files) → 1.38 MB (1 Router) = -77.2 % Output-Size
// (Gate >30 %); geteilter Kern (Middleware/Logger/DB-Client/Supabase/zod) wird
// einmal statt 26x gebundelt; Build-Walltime ~gleich (esbuild parallelisiert,
// Flaschenhals ist das groesste Bundle nicht der Count). Function-Count 153→128.
// Router 1.38 MB < ~3-MB-Vercel-Crash-Schwelle. EMPFEHLUNG: ROLLOUT → Phase 6e
// (6.250+) freigegeben. Test bundle-grouping-prototype.test.ts (54: alle 26
// Endpoints GET+POST byte-identisch via Router vs Single-File + Count + 404).
// 6.200.0 — 6.265 (Pricing-Reset, Code-Haelfte): MU/RS-Markups auf 11%/12%
// gesenkt (war 15%/20%), UVP-Faktor damit 1.20 → 1.2432. Daniel-Spec 2026-06-03
// nach Markt-Re-Analyse (alte Marge zu hoch, bewusste Verschiebung Richtung
// Partner-Acquisition). DB-Haelfte (Migration 0085 Default 18→11 + Backfill +
// Settings + master_products + partner_catalog) war schon via Plan-Chat live;
// dieser Cut zieht die Code-Seite nach: (a) shared/calc/bessPricing.ts
// EK_TO_RESELLER_MARKUP 1.15→1.11, RESELLER_TO_CUSTOMER_MARKUP 1.20→1.12
// (EK_TO_CUSTOMER_MARKUP rechnet sich auto auf 1.2432). (b) shared/partners/
// pricing-policy.ts PARTNER_MARKUP_PERCENT_DEFAULT 18→11, _MAX 35→22
// (Break-Even Partner-Preis=UVP liegt jetzt bei 24.32%, Cap 22 laesst ~2%
// Restmarge bei Max). (c) Migration 0086 (CHECK 0..35 → 0..22, kein Backfill —
// alle Werte schon 11.00; Plan-Chat applied NACH diesem Push, Crash-
// Sicherheits-Reihenfolge Code-Cap vor DB-Cap). (d) UI PriceFormulaHint +
// PartnerEditModal ziehen aus den Konstanten (max=22, Hint "Empfohlen 11%").
// Tests: partner-pricing-policy (0..22/Default 11/23+30 reject), partner-
// approval-service (23 reject + 22 akzeptiert), partner-portal-panel (max=22 +
// Hint 11%), partner-catalog-rebuild (22%-Boundary), neuer migration-0086-
// markup-cap-22, plus alle bess-seed/calc-Tests mit 1.11/1.12/1.2432 (EGS257
// Battery-EK 31'577 → 30'479, tCost-DoD 167'049 → 162'657, Cross-Repo-Snapshot
// regeneriert). full suite 6239 passed (1 Baseline-Flake vercel-ignore).
// 6.201.0 (7.5): OS-CalcEditor BESS-Refactor — Multi-Produkt-Konfigurator
// (BessConfiguratorModalForPl) ersetzt BessSeedForm + UnifiedCalcTab-BESS-
// Section, EK sichtbar fuer PL/admin, offerType-Toggle, server-side Multi-Line-
// Merge (mergeBessCalcDatas, Single-Line byte-identisch). seedBessCalc + PDF
// unangetastet.
// 6.202.0 (7.2): Public-Endpoint /api/public/bess-uvp-catalog (kein Auth,
// CORS-Allowlist, Edge-Cache 300s) + MasterCatalogService.listBessUvpCatalog
// (UVP sichtbar, EK nie). Vorarbeit fuer Web-Konfigurator 7.3.
// 6.203.0 (7.4): Lead-Intake-Erweiterung + OS-Pre-Fill fuer BESS-Konfigurator-
// Leads. ARCHITEKTUR-KORREKTUR ggue. Spec: OS hat KEINE web_leads-Tabelle —
// jeder Website-Lead IST bereits ein projects-Row (lead_intakes + auto-create,
// 5.29). „BESS-Calc starten" reichert deshalb den BESTEHENDEN Lead-Projekt-Row
// an (Customer + calcData.bess) statt ein zweites Projekt anzulegen (Prinzip 1).
// (a) shared/schemas/bessConfigSnapshot.ts — zod-Schema fuer den Cross-Repo-
// Snapshot (metadata.bess_config, lead_type="bess_configurator"), strikt auf
// lines/qty, tolerant gegen unbekannte addOn-Keys (forward-compat) + Helper
// (readBessConfigSnapshot/isBessConfiguratorLead/summarizeBessSnapshot). (b)
// leadIntakeView: View-DTO traegt jetzt leadType + bessConfig (der flache
// metadata-View wuerde den verschachtelten Snapshot verwerfen). (c) NEU
// LeadToProjectService.convertBessConfiguratorLead — Customer-Create + Link +
// CalcService.seedBess(multi) + Drift-Check (master_products-UVP vs Snapshot,
// >1% → Warnung) + Audit lead_converted_to_project. (d) NEU Endpoint POST
// /api/leads/convert-to-project (withRole pl/admin/superadmin). (e) NEU Hook
// useLeadConvert. (f) NEU BessConfigSnapshotTable (reusable Cart-Tabelle);
// ProjectLeadIntakeSection rendert sie + „BESS-Calc starten"-CTA + Drift-
// Warnung; LeadDashboardPage-Inbox zeigt BESS-Badge + Cart-Preview. (g) Statt
// neuem Notification-Type (Prinzip 1) traegt das bestehende project_new_from_
// website jetzt bessCartTotalChf (Row zeigt "BESS-Konfigurator · CHF X").
// Tests: lead-intake-bess-configurator (Schema), lead-to-project-service,
// convert-to-project-endpoint, bess-config-snapshot-table, web-lead-detail-view,
// notification-row erweitert + E2E lead-to-bess-calc-flow (authored). KEINE
// Migration (additives JSONB + text-Audit-action).
// 6.204.0 — 6.260 (Phase 6e): system/-Domain Bundle-Grouping produktiv. Die 26
// `system/*`-Endpoints laufen jetzt unter EINER Vercel-Function `system/_all.js`
// (Hono-Router + adapt()-Shim, byte-Parity). `bundle-api.mjs` gruppiert `system/`
// per Default (GROUPED_DOMAINS), `vercel.json` rewrited `/api/system/:path*` →
// `/api/system/_all`. Vercel-Invocation via benannte Method-Exports (GET..HEAD)
// = handle(app) aus hono/vercel. system-Domain 6.05 MB → 1.38 MB (−77 %),
// Function-Count 153 → 128. Single-File-Module bleiben als Importquellen liegen
// (Daniel-Entscheid: kein 97-Import-Rewrite). Tests: bundle-grouping-prototype
// (P0/CI-required, 26 Routen byte-Parity) + system-routes-no-single-files
// (Build-Invariante). KEINE Migration.
// 6.205.0 — 6.261 (Phase 6e): projects/-Domain Bundle-Grouping produktiv
// (zweitdichteste Domain). Die 28 `projects/*`-Endpoints laufen jetzt unter
// EINER Vercel-Function `projects/all.js` (Hono-Router + adapt()-Shim, byte-
// Parity, identisches Pattern wie 6.260). `bundle-api.mjs` gruppiert `projects/`
// per Default (GROUPED_DOMAINS += "projects"), `vercel.json` rewrited
// `/api/projects/:path*` → `/api/projects/all`. Pre-Check: Router 0.93 MB (28
// Single-Files 13 MB → −93 %), komfortabel unter Vercel-3-MB-Crash-Schwelle →
// KEIN Split noetig (Calc-Engine + bess-Seeds + Bundle-PDF passen). Der
// Root-Endpoint `/api/projects` (api-src/projects.ts) bleibt eigene Function
// (Rewrite `:path*` verlangt trailing `/`). Function-Count 130 → 103. Tests:
// bundle-grouping-prototype um 28 projects-Routen byte-Parity erweitert +
// projects-routes-no-single-files (Build-Invariante). KEINE Migration.
// 6.207.0 — 6.263 (Phase 6e): offers/ + partners/-Domain Bundle-Grouping
// produktiv. Die 14 `offers/*` + 17 `partners/*`-Endpoints laufen jetzt unter
// ZWEI Vercel-Functions `offers/all.js` + `partners/all.js` (Hono-Router +
// adapt()-Shim, byte-Parity, identisches Pattern wie 6.260/6.261). KEIN
// Router-Auth — jeder Handler bringt seine eigene Pipeline mit (X-API-Key fuer
// Web-Repo-Shop, withAuth/withRole(superadmin) fuer Sandro-Admin, Portal-Pfade
// fuer Customer-Portal); `adapt()` reicht Header/Query/Body transparent durch.
// `bundle-api.mjs` GROUPED_DOMAINS += "offers","partners"; `vercel.json`
// rewrited `/api/offers/:path*` + `/api/partners/:path*` → `.../all`. Pre-Check:
// offers-Router 1.11 MB + partners-Router 0.91 MB (beide komfortabel unter
// Vercel-3-MB-Crash-Schwelle, puppeteer/chromium external) → KEIN Split. Zwei
// separate Router (Domain-Trennung, Cache-Granularitaet, Routing-Klarheit).
// Function-Count 77 → 57 (−20: 31 Single-Files → 2 Router). Tests: bundle-
// grouping-prototype um 14+17 Routen byte-Parity erweitert + offers/partners-
// routes-no-single-files (Build-Invarianten) + offers-partners-auth-paths
// (AUTH_MISSING / ROLE_FORBIDDEN / X-API-Key 401+400 Gates). system-routes-no-
// single-files-Sanity-Anker partners/ → finance/ (naechste ungegroupte Domain).
// KEINE Migration. Convoltas-Critical-Path: Web-Repo-Endpoints (quotes,
// customer-quote-*, bess-product-meta, profiles-approved) + Customer-Portal
// (portal-orders, accept-by-phone, confirm-order) byte-identisch erreichbar.
//
// 6.208.0 (6.264, Phase 6e FINAL): finance/ (9) + bills/ (2) + customers/ (2) +
// invoices/ (1) Long-Tail-Grouping. VARIANTE A (vier separate Mini-Router statt
// einem business/_all.ts): finance/all.js, bills/all.js, customers/all.js,
// invoices/all.js (Hono + adapt()-Shim + named Method-Exports GET..HEAD, byte-
// Parity, Pfad-basiert). KEIN Router-Auth — jeder Handler self-auth via pipe().
// Pre-Check: finance 0.71 MB / bills 0.17 MB / customers 0.19 MB / invoices
// 0.56 MB (alle weit unter 3-MB-Crash-Schwelle). B waere groessen-zulaessig
// (kombiniert <2.5MB, KEINE Cross-Repo-Konsumenten), aber A wegen maxDuration-
// Isolation (nur finance/all.js braucht 300s wegen bexio-sync-now/bexio-invoice-
// pdf; bills/customers/invoices auf Standard) + Cache-Granularitaet; die 3
// eingesparten Functions rechtfertigen das Sammel-Bundle nicht. Function-Count
// 48 → 38 (−10: 14 Single-Files → 4 Router). vercel.json: 4 Rewrites +
// functions api/finance/all.js maxDuration 300. bundle-api GROUPED_DOMAINS +=
// finance,bills,customers,invoices. Tests: bundle-grouping-prototype um
// 9+2+2+1 Routen byte-Parity erweitert + 4 *-routes-no-single-files (Build-
// Invarianten). system-routes-no-single-files-Sanity-Anker finance/ → portal/
// (explizit nicht-gegroupte Cross-Repo-Domain). Cross-Repo-Audit (Web-Repo):
// KEINE Konsumenten auf finance/bills/customers/invoices. Phase 6e komplett
// abgeschlossen: Function-Count 155 → 38 (~75% Reduction).
// 6.218.0 — Baustein 6.254 (Phase 6 Refactoring-Abschluss): App-Version in
// app-version.json herausgeloest + zur Build-Zeit injiziert (siehe Header).
// Diese Datei ist statisch; die Bump-Zahl steht in app-version.json.
export const APP_VERSION = process.env.APP_VERSION ?? "dev";
